// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\WidgetBookingPriceDiscountResponse

export type WidgetBookingPriceDiscountApiResponse = {
	code: string;
	amount: number;
};

export type WidgetBookingPriceDiscount = {
	code: string;
	amount: number;
};

export function hydrateWidgetBookingPriceDiscount(data: WidgetBookingPriceDiscountApiResponse): WidgetBookingPriceDiscount {
	return { ...data };
}